exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n/* make sure to keep these in sync with other constants,\r\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\r\n\r\n/* layout contants from `layout-constants.js` */\r\n\r\n.tag-button_tag-button_3MxU5 {\r\n    padding: .625rem 1rem;\r\n    background: var(--looks-secondary);\r\n    border-radius: 1.375rem;\r\n    color: white;\r\n    height: 2.5rem;\r\n}\r\n\r\n.tag-button_tag-button-icon_3VB4Q {\r\n    max-width: 1rem;\r\n    max-height: 1rem;\r\n}\r\n\r\n.tag-button_active_1IIH9 {\r\n    background: var(--data-primary);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"tag-button": "tag-button_tag-button_3MxU5",
	"tagButton": "tag-button_tag-button_3MxU5",
	"tag-button-icon": "tag-button_tag-button-icon_3VB4Q",
	"tagButtonIcon": "tag-button_tag-button-icon_3VB4Q",
	"active": "tag-button_active_1IIH9"
};